import { appsyncQuery } from './appsync-client.js'

const NOTIFICATION_FIELDS = `
  id type title body targetOrg targetRoles targetUserId link
  createdAt createdBy expiresAt dismissedAt expired
`

const LIST_NOTIFICATIONS = `
  query ListNotifications($history: String) {
    listNotifications(history: $history) { ${NOTIFICATION_FIELDS} }
  }
`

const DISMISS_NOTIFICATION = `
  mutation DismissNotification($notificationId: ID!) {
    dismissNotification(notificationId: $notificationId) { ${NOTIFICATION_FIELDS} }
  }
`

const LIST_ALL_NOTIFICATIONS = `
  query ListAllNotifications($targetOrg: String) {
    listAllNotifications(targetOrg: $targetOrg) { ${NOTIFICATION_FIELDS} }
  }
`

const PUBLISH_NOTIFICATION = `
  mutation PublishNotification($input: PublishNotificationInput!) {
    publishNotification(input: $input) { ${NOTIFICATION_FIELDS} }
  }
`

const DELETE_NOTIFICATION = `
  mutation DeleteNotification($notificationId: ID!, $targetOrg: String!) {
    deleteNotification(notificationId: $notificationId, targetOrg: $targetOrg)
  }
`

export const ON_NOTIFICATION_PUBLISHED = `
  subscription OnNotificationPublished($targetOrg: String!) {
    onNotificationPublished(targetOrg: $targetOrg) { ${NOTIFICATION_FIELDS} }
  }
`

export async function listNotifications({ history = false } = {}) {
  const data = await appsyncQuery(LIST_NOTIFICATIONS, { history: history ? 'true' : null })
  return data?.listNotifications || []
}

export async function dismissNotification(notificationId) {
  const data = await appsyncQuery(DISMISS_NOTIFICATION, { notificationId })
  return data?.dismissNotification
}

export async function listAllNotifications(targetOrg) {
  const data = await appsyncQuery(LIST_ALL_NOTIFICATIONS, { targetOrg: targetOrg || null })
  return data?.listAllNotifications || []
}

export async function publishNotification(input) {
  const data = await appsyncQuery(PUBLISH_NOTIFICATION, { input })
  return data?.publishNotification
}

export async function deleteNotification(notificationId, targetOrg) {
  const data = await appsyncQuery(DELETE_NOTIFICATION, { notificationId, targetOrg })
  return data?.deleteNotification
}
